// User Tracking Implementation via New Relic Browser API

import { USER_OPTIONS_MAP } from '../constants/TrackingConstants';

export const NEW_RELIC_CUSTOM_ATTRIBUTES = [
    ...Object.values(USER_OPTIONS_MAP),
    'environment',
];

export const getNewRelicBrowserAPI = () => window.newrelic;

export const newRelicTrackEvent = (event, attributes) => {
    const newRelicBrowserAPI = getNewRelicBrowserAPI();

    if (newRelicBrowserAPI) {
        newRelicBrowserAPI.addPageAction(event, attributes);
    }
};

export const newRelicAddCustomAttribute = (key, value) => {
    const newRelicBrowserAPI = getNewRelicBrowserAPI();

    if (newRelicBrowserAPI) {
        newRelicBrowserAPI.setCustomAttribute(key, value);
    }
};

export const newRelicSetUserId = (value) => {
    const newRelicBrowserAPI = getNewRelicBrowserAPI();

    if (newRelicBrowserAPI) {
        newRelicBrowserAPI.setUserId(value);
    }
};

export const newRelicIdentifyUser = (attributes) => {
    const { userId, ...attrs } = attributes;

    newRelicSetUserId(userId);
    Object.entries(attrs)
        .forEach(([key, value]) => newRelicAddCustomAttribute(key, value));
};

export const newRelicClearUserData = () => {
    newRelicSetUserId(null);
    NEW_RELIC_CUSTOM_ATTRIBUTES.forEach((value) => newRelicAddCustomAttribute(value, null));
};
